import { PaintedScene, type PaintedSceneInitData } from './PaintedScene';
import type { PaintedSceneAssetSpec } from './sceneAssetSpec.schema';
import type { JourneyManifest } from './journeyManifest.schema';

export const HEARTH_SCENE_PHASER_KEY = 'HearthScene' as const;
export const HEARTH_SCENE_MANIFEST_KEY = 'scene-2-hearth' as const;

export class HearthScene extends PaintedScene {
  constructor() {
    super(HEARTH_SCENE_PHASER_KEY, HEARTH_SCENE_MANIFEST_KEY);
  }

  protected provideAssetSpec(): PaintedSceneAssetSpec | null {
    return null;
  }

  protected provideManifest(): JourneyManifest | null {
    return null;
  }

  protected onInteractionTriggered(): void {
    const fired = (this.registry.get('hearth:interactions-fired') as number | undefined) ?? 0;
    this.registry.set('hearth:interactions-fired', fired + 1);
  }

  init(data?: PaintedSceneInitData): void {
    super.init(data);
  }
}
